import 'lightgallery/css/lightgallery-bundle.min.css';

import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

export const render = (selector) => {
  const element = document.querySelector(selector);

  lightGallery(element, {
    plugins: [lgThumbnail],
  });
}
